/** Towlot / auction UI constants — keep aligned with backend where noted. */

/** Vehicle `suggested_days_for_auction` — matches backend inclusion 1..180 */
export const suggestedDaysForAuction = {
  min: 1,
  max: 180,
  default: 90
};

// Aliases / catalog: keep in sync with roadsider-backend/app/models/towlot_vehicle/color_mapper.rb.
export const towlotColorAliases = {
  grey: 'Gray',
  gray: 'Gray',
  'dark gray': 'Gray',
  'dark grey': 'Gray',
  'light gray': 'Gray',
  'light grey': 'Gray',
  'silver gray': 'Silver',
  'silver grey': 'Silver',
  gunmetal: 'Gray',
  'gunmetal gray': 'Gray',
  'gunmetal grey': 'Gray',
  graphite: 'Gray',
  slate: 'Gray',
  'charcoal gray': 'Charcoal',
  'charcoal grey': 'Charcoal',
  offwhite: 'Off White',
  'off white': 'Off White',
  'off-white': 'Off White',
  'n/a': 'N/A',
  na: 'N/A',
  unknown: 'N/A',
  tbd: 'N/A'
};

export const towlotColors = [
  { value: 'Black', label: 'Black' },
  { value: 'Blue', label: 'Blue' },
  { value: 'White', label: 'White' },
  { value: 'Gray', label: 'Gray' },
  { value: 'Red', label: 'Red' },
  { value: 'Brown', label: 'Brown' },
  { value: 'Gold', label: 'Gold' },
  { value: 'Green', label: 'Green' },
  { value: 'Silver', label: 'Silver' },
  { value: 'Yellow', label: 'Yellow' },
  { value: 'Charcoal', label: 'Charcoal' },
  { value: 'Off White', label: 'Off White' },
  { value: 'Tan', label: 'Tan' },
  { value: 'Beige', label: 'Beige' },
  { value: 'Burgundy', label: 'Burgundy' },
  { value: 'Turquoise', label: 'Turquoise' },
  { value: 'Pink', label: 'Pink' },
  { value: 'Purple', label: 'Purple' },
  { value: 'N/A', label: 'N/A' }
];

export const towlotCarTitles = [
  { value: 'clear_title', label: 'Clear Title' },
  { value: 'possessory_lien', label: 'Possessory lien paper work, enabling a title' },
  { value: 'salvage', label: 'Salvage' },
  { value: 'rebuilt_salvage', label: 'Rebuilt Salvage' },
  { value: 'previous_salvage', label: 'Previous Salvage' },
  { value: 'repossession', label: 'Repossession' },
  { value: 'restored_title', label: 'Restored Title' },
  { value: 'bill_of_sale_only', label: 'Bill of sale only' },
  { value: 'disposal_paperwork', label: 'Disposal paperwork' },
  { value: 'na', label: 'N/A' },
  { value: 'dismantle_title', label: 'Dismantle Title' },
  { value: 'ks_certificate', label: 'KS Certificate of Compliance enabling a title' },
  { value: 'other', label: 'Other' }
];

export const towlotCarTypes = [
  { value: 'abandoned', label: 'Abandoned' },
  { value: 'private_tow', label: 'Private Tow' },
  { value: 'police_tow', label: 'Police Tow' },
  { value: 'arrest', label: 'Arrest' },
  { value: 'repo', label: 'Repo' },
  { value: 'impound', label: 'Impound' },
  { value: 'charity', label: 'Charity' },
  { value: 'used', label: 'Used' },
  { value: 'consignment', label: 'Consignment' },
  { value: 'na', label: 'N/A' }
];

export const towlotKeysTypes = [
  { value: 'yes', label: 'Yes' },
  { value: 'no', label: 'No' },
  { value: 'starts_with_screwdriver', label: 'Starts with Screwdriver' },
  { value: 'na', label: 'N/A' }
];

export const towlotTransmissions = [
  { value: 'automatic', label: 'Automatic' },
  { value: 'manual', label: 'Manual' },
  { value: 'na', label: 'N/A' }
];

export const towlotExterior = [
  'Clean',
  'Nice Looking Vehicle',
  'Normal Wear',
  'Has Catalytic Converter',
  'Body Rough',
  'Major Damage',
  'Minor Damage',
  'Fire Damage',
  'Hail Damage',
  'Rollover Damage'
];

export const towlotInterior = [
  'Clean',
  'Normal Wear',
  'Rough',
  'Leather Seats',
  'Cloth Seats',
  'Fire Damage',
  'Air Bags Deployed'
];

export const towlotMechanical = [
  'Runs and Drives',
  'Runs and Goes into Gear',
  'Appears to be drivable',
  'Unknown',
  "Vehicle won't start",
  "Cranks, won't start",
  'Motor knocks',
  'Motor Apart',
  'Motor Locked Up',
  'Low Compression',
  'Runs Only',
  'Needs Transmission Work'
];

export const towlotOptions = [
  'Loaded with all options',
  'Power Locks',
  'Power Windows',
  'Power Seats',
  'Moonroof',
  '4x4'
];

export const towlotTermsOfSale = [
  'Examine Vehicle Carefully Before Bidding',
  'Sold as is, where is, no warranty'
];

export const towlotLegalComplianceLabel =
  'The seller warrants that the vehicle offered for auction complies with all applicable state laws.';
export const towlotRoadsiderTermsLabel =
  'The seller agrees to all terms, conditions, and pricing set forth by Roadsider.';

export const towlotStatuses = {
  SYNCED: 'synced',
  FAILED: 'failed',
  SOLD: 'sold',
  LISTED: 'listed',
  UNSOLD: 'unsold',
  WITHDRAWN: 'withdrawn'
};

export const towlotStatusLabels = {
  [towlotStatuses.SYNCED]: 'Synced to Towlot',
  [towlotStatuses.LISTED]: 'On Auction',
  [towlotStatuses.FAILED]: 'Sync Failed',
  [towlotStatuses.SOLD]: 'Sold',
  [towlotStatuses.UNSOLD]: 'Unsold',
  [towlotStatuses.WITHDRAWN]: 'Withdrawn'
};
